import React from 'react';
import styles from './ProjectCard.module.css';

function ProjectCard({ imageUrl, projectName = 'PROJECT NAME', client = 'CLIENT', year = 'YEAR' }) {
  const backgroundStyle = imageUrl
    ? { backgroundImage: `url(${imageUrl})` }
    : {};

  return (
    <div className={styles.card}>
      <div className={styles.image} style={backgroundStyle} />
      <div className={styles.details}>
        <p className={styles.title}>{projectName}</p>
        <p className={styles.meta}>{client}</p>
        <p className={styles.meta}>{year}</p>
      </div>
    </div>
  );
}

export default ProjectCard;


